import { useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Eye, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/announcements`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

// UTC ISO -> 'YYYY-MM-DDTHH:MM' in Eastern Time (for datetime-local inputs)
export const utcToEt = (iso) => {
  if (!iso) return "";
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
    .formatToParts(new Date(iso)).map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
};
export const fmtEt = (iso) => `${new Date(iso).toLocaleString("en-US", { timeZone: "America/New_York", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })} ET`;

const List = ({ title, rows, opened }) => (
  <div>
    <p className="text-sm font-semibold text-navy mb-1">{title} ({rows.length})</p>
    <div className="max-h-56 overflow-y-auto divide-y divide-slate-100 border border-slate-200 rounded-lg">
      {rows.length === 0 && <p className="text-xs text-slate-400 p-3">No one</p>}
      {rows.map((r) => (
        <div key={r.email} className="flex justify-between gap-3 px-3 py-1.5 text-sm">
          <span className="text-slate-700">{r.name}{r.business ? <span className="text-slate-400"> · {r.business}</span> : null}</span>
          {opened && <span className="text-xs text-slate-400 whitespace-nowrap">{new Date(r.opened_at).toLocaleString()}</span>}
        </div>
      ))}
    </div>
  </div>
);

// "Opened by X of Y dealers" button that opens the who-opened / who-hasn't list
export const ReadReceipts = ({ id, count = 0, total = 0 }) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const show = () => { setOpen(true); setData(null); axios.get(`${API}/${id}/reads`, auth()).then((r) => setData(r.data)).catch(() => setData({ opened: [], not_opened: [] })); };
  return (
    <>
      <button type="button" onClick={show} className="inline-flex items-center gap-1 text-xs text-teal hover:underline" data-testid={`announcement-reads-${id}`}>
        <Eye className="w-3.5 h-3.5" />Opened by {count} of {total} dealers
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid={`announcement-reads-dialog-${id}`}>
          <DialogHeader><DialogTitle className="font-heading text-navy">Who opened it</DialogTitle></DialogHeader>
          {!data ? <Loader2 className="w-5 h-5 animate-spin text-teal mx-auto" /> : (
            <div className="space-y-4"><List title="Opened" rows={data.opened} opened /><List title="Not opened yet" rows={data.not_opened} /></div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
